import http from '@services/http'
import { IPickList, IPublishPickList, IPublishPick, IControlPick, IPurchasePick } from '@protocol/pick'

export default {
  getPickList(data: IPickList.Params): Promise<IPickList.Schema> {
    return http.post('pick/list', data || {})
  },

  publishPick(data: IPublishPick.Params): Promise<IPublishPick.Schema> {
    return http.post('pick/publish', data || {})
  },

  controlPick(data: IControlPick.Params): Promise<IControlPick.Schema> {
    return http.post('pick/control', data || {})
  },

  purchasePick(data: IPurchasePick.Params): Promise<IPurchasePick.Schema> {
    return http.post('pick/purchase', data || {})
  },

  // pick controller 작업이 끝나면 pick쪽으로 이동시켜야함
  getPublishPickList(data: IPublishPickList.Params): Promise<IPublishPickList.Schema> {
    return http.get('pick/publishPickList', data || {})
  },
}
